module.exports = __webpack_public_path__ + "static/media/Newspaperadvertising.2dcc913e.jpg";